import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { createAsyncThunkSafe } from '../../_base/createAsyncThunkSafe';

import { DTOWorkspaceChildEntityViewer } from '@shared/dto/+workspace/workspace_entity/dto_workspace_child_entity_viewer';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { STATE__workspace } from '../STATE__workspace';

export const remote_workspace_child_entity_update_viewer_status = createAsyncThunkSafe<void, DTOWorkspaceChildEntityViewer[]>(
  ENUM__network_event_client_to_server.WORKSPACE_CHILD_ENTITY_UPDATE_VIEWER_STATUS,
  async (updates, thunkApi): Promise<void> => {
    await send_to_server(ENUM__network_event_client_to_server.WORKSPACE_CHILD_ENTITY_UPDATE_VIEWER_STATUS, updates);
  },
);

export function init_remote_workspace_child_entity_update_viewer_status(builder: ActionReducerMapBuilder<STATE__workspace>) {
  builder
    .addCase(remote_workspace_child_entity_update_viewer_status.pending, (state, action) => {})
    .addCase(remote_workspace_child_entity_update_viewer_status.rejected, (state, action) => {})
    .addCase(remote_workspace_child_entity_update_viewer_status.fulfilled, (state, action: PayloadAction) => {});
}
